import { CONFIGURATOR_WALL_NO_COLORS_TEXT } from '@/shared/config/const';

export const getTitleByPickedColors = (pickedColors: (string | null)[]) => {
    const filteredColors = pickedColors.filter((color) => !!color);
    return filteredColors.length > 0 ? filteredColors.join(', ') : CONFIGURATOR_WALL_NO_COLORS_TEXT;
};
